import { ISvgShape } from "../../../types/Floorplan.types";

export interface IShapeCanvasControlsProps {
    shapes: ISvgShape[];
    selectedShapeIdx?: number;
}

const ShapeCanvasControls = (props: IShapeCanvasControlsProps) => {
    const { shapes, selectedShapeIdx } = props;
    if (selectedShapeIdx !== undefined) {
        const selectedShape = shapes[selectedShapeIdx];
        if (selectedShape) {
            const x = selectedShape.x+(selectedShape.width! / 2);
            const y = selectedShape.y+(selectedShape.height! / 2);
            let radius = Math.max(selectedShape.width!, selectedShape.height!);
            if (radius > 50) radius = 50;
            if (radius < 15) radius = 15;
            return (
                <svg id="shapeControlHandles" x={x} y={y} overflow="visible">
                    <g transform={`rotate(${shapes[selectedShapeIdx].rotation})`}>
                        <circle cx="0" cy="0" r={radius} stroke="#b7b7b7" strokeDasharray="4" fill="none" />
                        <circle id="shapeRotationHandle" cx={radius} cy={0 - radius} r="2" stroke="#999" strokeWidth="0.5" fill="white" />
                    </g>
                </svg>
            );
        }
    }
    return null;
};

export default ShapeCanvasControls;